import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { articleImageUrl } from "@/lib/api";

export default function ArticleCard({ article, testId }) {
  return (
    <Link data-testid={testId} to={`/insights/${article.slug}`} className="group block overflow-hidden border border-[#E5DFD3] bg-[#FDFBF7] shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
      <div className="aspect-[16/10] overflow-hidden bg-[#1C1613]">
        <img src={articleImageUrl(article.featured_image_path)} alt={article.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.035]" />
      </div>
      <div className="p-7">
        <div className="flex items-center justify-between gap-4 text-[11px] font-bold uppercase tracking-[0.18em] text-[#9B7437]">
          <span>{article.category}</span>
          <ArrowUpRight size={16} strokeWidth={1.5} />
        </div>
        <p data-testid={`article-reading-time-${article.slug}`} className="mt-3 text-[11px] font-semibold tracking-[0.12em] text-[#8A7D70]">{article.reading_time || 1} MIN READ</p>
        <h2 className="mt-4 font-serif text-3xl font-normal leading-tight text-[#1C1613]">{article.title}</h2>
        <p className="mt-4 text-sm leading-7 text-[#524842]">{article.summary}</p>
      </div>
    </Link>
  );
}
